module.exports = "<div\n  class=\"loading-indicator\"\n  ng-class=\"{ isLoading: vm.isLoading }\"\n  ng-show=\"vm.isLoading\">\n  <div ng-class=\"vm.indicator\">\n    <div class=\"dot\"></div>\n    <div class=\"dot\"></div>\n    <div class=\"dot\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-loading-indicator/src/loading-indicator.html
// module id = 1472
// module chunks = 12